"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerName = void 0;
const common_1 = require("@angular/common");
class ManufacturerName {
    transform(value) {
        const titleCase = new common_1.TitleCasePipe();
        if (value !== 'LG') {
            return titleCase.transform(value);
        }
        else {
            return value;
        }
    }
}
exports.ManufacturerName = ManufacturerName;
//# sourceMappingURL=manufacturerName.pipe.js.map